import { required, optional, array, obj } from 'AppReact/schema';

const onCall = {
  start_date: required('date'),
  end_date: required('date'),
  tech_id: required('integer')
}

export const tech = {
  id: required('integer'),
  activated_at: optional('jsDate'),


  can_edit: required('boolean'), //to be removed
  category_ids: array('integer'), //to be removed
  description: required('string'), //to be removed
  email: required('string'), //to be removed
  lat: optional('number'), //to be removed
  lng: optional('number'), //to be removed
  pass_code: optional('string'), //to be removed
  phone_number: optional('string'), //to be removed
  presence: optional('boolean'), //to be removed
  require_image: optional('boolean'), //to be removed
  on_calls: array(obj(onCall)),
  month_stats: obj({
    completion_time: optional('number'),
    rating: optional('number')
  }), //to be removed


  deactivated_at: optional('jsDate'),
  inserted_at: required('jsDate'),
  active: required('boolean'),
  image: optional('string'),
  top: optional('integer'),
  name: required('string'),
  type: required('string'),
  on_calls_count: required('integer'),
  property_ids: array('integer'),
  stats: obj({
    assigned: required('integer'),
    callbacks: optional('integer'),
    callback: optional('integer'),
    completed: required('integer'),
    completion_time: optional('number'),
    rating: optional('number'),
    reviews: optional('integer'),
    withdrawn: optional('integer'),
  })
}

export const property = {
  active: required('boolean'),
  code: optional('string'),
  external_id: optional('string'),
  icon: optional('string'),
  id: required('integer'),
  lat: optional('string'),
  lng: optional('string'),
  name: required('string'),
  region: required('string')
}

export const defaultTech = {
  id: 1,
  activated_at: null,


  can_edit: false,
  category_ids: [],
  description: '',
  email: 'test@default.com',
  lat: null,
  lng: null,
  pass_code: null,
  phone_number: null,
  presence: null,
  require_image: null,
  on_calls: [],
  month_stats: {
    completion_time: null,
    rating: null,
  },

  deactivated_at: null,
  top: null,
  inserted_at: '2021-10-14',
  active: false,
  image: null,
  name: 'Test',
  type: '',
  on_calls_count: 0,
  property_ids: [],
  top: 0,
  stats: {
    assigned: 0,
    callbacks: 0,
    completed: 0,
    completion_time: null,
    rating: null,
    reviews: 0,
    withdrawn: 0,
  }
}